function useQueryParams() {
	// eslint-disable-next-line no-undef
	return new URLSearchParams(window.location.search);
}

export default useQueryParams;
